var app = angular.module('leonardo');

var DynamicFormController = function ($scope, $q, $window, $rootScope, $document, $state, formObj, $builder, ngDialog,
    AccountService, DynamicFormRestService, AccountUserService, NotificationService,
    FormErrorsService, AuthDataService, AttachmentService, FolderService, SectorRestService) {
        // This is intentional do_something blank function
    };
app.controller('DynamicFormController', [
    '$scope', '$q', '$window', '$rootScope', '$document', '$state', 'formObj',
    '$builder', 'ngDialog', 'AccountService', 'DynamicFormRestService', 'AccountUserService', 'NotificationService',
    'FormErrorsService', 'AuthDataService', 'AttachmentService', 'FolderService', 'SectorRestService', DynamicFormController]);
